module.exports = __webpack_public_path__ + "img/android.77f346b6.png";